/* Product page — gallery, variant picker
   (the mobile bottom bar is sections/sst-bar.liquid + sst-bar.js)
   Pairs with sections/sst-product-main.liquid.

   Add-to-cart itself is handled by the theme's own <product-form> element
   (product-form.js) so the cart drawer opens. This file only feeds that
   element the right variant id and keeps the UI in sync. */
(function () {
  'use strict';


  /* ---------- gallery ---------- */
  var mainImg = document.getElementById('sst-gal-main-img');
  var thumbs = document.querySelectorAll('[data-sst-thumb]');
  var videos = document.querySelectorAll('[data-sst-video]');

  // Stop and hide every video slot. Shopify videos are paused; YouTube/Vimeo
  // iframes are removed (the only reliable way to stop them).
  function hideVideos() {
    videos.forEach(function (slot) {
      if (slot.hidden) return;
      var v = slot.querySelector('video');
      if (v) v.pause();
      var f = slot.querySelector('iframe');
      if (f) f.remove();
      slot.hidden = true;
    });
  }
  function showImage(src) {
    hideVideos();
    if (!mainImg) return;
    if (src) { mainImg.src = src; mainImg.removeAttribute('srcset'); }
    mainImg.hidden = false;
  }
  function showVideo(id) {
    hideVideos();
    var slot = document.querySelector('[data-sst-video="' + id + '"]');
    if (!slot) return;
    if (mainImg) mainImg.hidden = true;
    var tpl = slot.querySelector('template');
    if (tpl && !slot.querySelector('iframe')) slot.appendChild(tpl.content.cloneNode(true));
    slot.hidden = false;
    var v = slot.querySelector('video');
    if (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  }

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (thumb.hasAttribute('data-video')) showVideo(thumb.getAttribute('data-video'));
      else showImage(thumb.getAttribute('data-full'));
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  /* ---------- variant picker ---------- */
  var dataEl = document.querySelector('[data-sst-variants]');
  var optsWrap = document.querySelector('[data-sst-opts]');
  var variants = [];

  if (dataEl) {
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.warn('SST product: could not parse variant data', e);
    }
  }

  var variantIdInput = document.querySelector('[data-sst-variant-id]');
  var addBtn = document.querySelector('[data-sst-add]');
  var addBtnText = document.querySelector('[data-sst-add-text]');
  var hint = document.querySelector('[data-sst-hint]');
  var priceCurrent = document.querySelector('[data-sst-price-current]');
  var priceCompare = document.querySelector('[data-sst-price-compare]');
  var stockEl = document.querySelector('[data-sst-stock]');
  var addLabel = addBtnText ? addBtnText.textContent.trim() : 'Add to cart';

  function selectedOptions() {
    if (!optsWrap) return [];
    var groups = optsWrap.querySelectorAll('.sst-opt');
    var out = [];
    groups.forEach(function (group, i) {
      var checked = group.querySelector('input[data-sst-opt]:checked');
      out[i] = checked ? checked.value : null;
    });
    return out;
  }

  function matchVariant(selection) {
    if (selection.indexOf(null) !== -1) return null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var same = true;
      for (var j = 0; j < selection.length; j++) {
        if (v.options[j] !== selection[j]) { same = false; break; }
      }
      if (same) return v;
    }
    return null;
  }

  function setStock(available) {
    if (!stockEl) return;
    stockEl.classList.toggle('sst-buy__stock--in', available);
    stockEl.classList.toggle('sst-buy__stock--out', !available);
    var label = stockEl.querySelector('span');
    if (label) label.textContent = available ? 'In stock' : 'Out of stock';
  }

  function updateChosenLabels(selection) {
    selection.forEach(function (value, i) {
      var el = document.querySelector('[data-sst-opt-chosen="' + (i + 1) + '"]');
      if (el) el.textContent = value || '';
    });
  }

  function onSelectionChange() {
    var selection = selectedOptions();
    updateChosenLabels(selection);

    var variant = matchVariant(selection);
    var complete = selection.indexOf(null) === -1;

    if (hint) hint.hidden = complete;

    if (!variant) {
      // Either not everything is chosen yet, or that combination doesn't exist.
      if (variantIdInput) variantIdInput.value = '';
      if (addBtn) addBtn.setAttribute('aria-disabled', 'true');
      if (addBtnText) {
        addBtnText.textContent = complete ? 'Unavailable' : 'Select options';
      }
      if (complete && hint) {
        hint.hidden = false;
        hint.textContent = 'That combination is not available.';
      }
      return;
    }

    if (variantIdInput) variantIdInput.value = variant.id;
    // Delivery card (sst-delivery.js) re-prices by weight.
    document.dispatchEvent(new CustomEvent('sst:variant', { detail: variant }));

    if (priceCurrent) priceCurrent.textContent = variant.price;
    if (priceCompare) {
      if (variant.compare_at_price) {
        priceCompare.textContent = variant.compare_at_price;
        priceCompare.hidden = false;
      } else {
        priceCompare.hidden = true;
      }
    }

    setStock(variant.available);

    if (addBtn) {
      if (variant.available) {
        addBtn.removeAttribute('aria-disabled');
        if (addBtnText) addBtnText.textContent = addLabel;
      } else {
        addBtn.setAttribute('aria-disabled', 'true');
        if (addBtnText) addBtnText.textContent = 'Out of stock';
      }
    }

    if (variant.featured_image && mainImg) showImage(variant.featured_image);

    // Keep the URL shareable/refreshable on the chosen variant.
    if (window.history && history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url.toString());
    }
  }

  if (optsWrap) {
    optsWrap.addEventListener('change', function (e) {
      if (e.target.matches('input[data-sst-opt]')) onSelectionChange();
    });
    // Sync on load in case the browser restored a checked radio.
    if (optsWrap.querySelector('input[data-sst-opt]:checked')) onSelectionChange();
  }

  /* ---------- call button ----------
     Phones dial. Desktop has nothing to dial with, so the first click shows
     the number instead; later clicks follow tel: as normal (Skype etc.).
     data-ss-channel tells the attribution script (ss-attribution.liquid)
     this tap was a reveal, not a dial — it runs after this handler. */
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  document.querySelectorAll('[data-sst-call-reveal]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (canHover && !a.classList.contains('is-revealed')) {
        e.preventDefault();
        a.classList.add('is-revealed');
        a.setAttribute('data-ss-channel', 'call_reveal');
        var t = a.querySelector('[data-sst-call-text]');
        if (t) t.textContent = a.getAttribute('data-number');
        return;
      }
      a.removeAttribute('data-ss-channel');
    });
  });
  /* ---------- description: Read more ----------
     Collapse only when the text is longer than the collapsed height, so
     short descriptions never get a pointless button. */
  var desc = document.querySelector('[data-sst-desc]');
  if (desc) {
    var body = desc.querySelector('[data-sst-desc-body]');
    var more = desc.querySelector('[data-sst-desc-more]');
    var label = desc.querySelector('[data-sst-desc-label]');

    // Hide description images that don't load (e.g. old WordPress
    // /wp-content/ links left over from the previous site) instead of
    // showing empty broken-image boxes.
    if (body) {
      body.querySelectorAll('img').forEach(function (img) {
        function drop() { img.remove(); }
        if (img.complete && img.naturalWidth === 0) drop();
        else img.addEventListener('error', drop);
      });
    }

    desc.classList.add('is-clamped');
    if (body && more && body.scrollHeight > body.clientHeight + 8) {
      more.hidden = false;
      more.addEventListener('click', function () {
        var open = desc.classList.toggle('is-clamped') === false;
        more.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (label) label.textContent = open ? 'Show less' : 'Read more';
        if (!open) desc.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      });
    } else {
      desc.classList.remove('is-clamped');
    }
  }
})();
